import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'

type State = {
  collapsed: boolean
}

type Actions = {
  setCollapsed: (collapsed: boolean) => void
  toggle: () => void
}

export const useSidebarStore = create<State & Actions>()(
  devtools(
    zustandPlugin(
      (set) => ({
        collapsed: true,
        setCollapsed: (collapsed) => set({ collapsed }, false, 'setCollapsed'),
        toggle: () =>
          set((s) => ({ collapsed: !s.collapsed }), false, 'toggle'),
      }),
      'sidebar',
    ),
    { name: 'EasyTacho', store: 'sidebar' },
  ),
)
